import { Engine } from '@/core/Engine';
import { createGameController, GameController } from '@/game/GameController';
import { GameStateEvents, GamePhase } from '@/game/GameStateManager';
import { CombatEvents } from '@/combat/CombatSystem';
import { UIManager } from '@/ui/UIManager';

function main(): void {
  try {
    const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;

    if (!canvas) {
      throw new Error('Canvas element not found');
    }

    console.log('Canvas found:', canvas.clientWidth, 'x', canvas.clientHeight);

    // Initialize the engine
    const engine = new Engine({ canvas });
    console.log('Engine created');
    console.log('Hex tiles:', engine.hexGrid.getAllTiles().length);

    // Create game controller with all systems
    const game = createGameController(engine);
    console.log('Game controller created');

    // Debug: Log game events
    engine.eventBus.on<{ previousPhase: GamePhase; newPhase: GamePhase }>(
      GameStateEvents.PHASE_CHANGED,
      (data) => {
        console.log(`Phase changed: ${data.previousPhase} → ${data.newPhase}`);
      }
    );

    engine.eventBus.on(CombatEvents.UNIT_ATTACKED, (data) => {
      console.log('Attack:', data);
    });

    engine.eventBus.on(CombatEvents.UNIT_DIED, (data) => {
      console.log('Unit died:', data);
    });

    // Start the game loop
    engine.start();

    // Create UI containers
    const uiContainer = document.getElementById('ui-overlay') || document.body;

    // Create UI Manager (handles battle lobby, bottom nav, and game UI)
    const ui = new UIManager(uiContainer, engine.eventBus, game);

    // Expose for debugging
    (window as unknown as { engine: Engine; game: GameController; ui: UIManager }).engine = engine;
    (window as unknown as { engine: Engine; game: GameController; ui: UIManager }).game = game;
    (window as unknown as { engine: Engine; game: GameController; ui: UIManager }).ui = ui;

    console.log('Character Battle initialized');
    console.log('Select "Play vs AI" for single-player or "Find Match" for multiplayer');
  } catch (error) {
    console.error('Failed to initialize game:', error);
  }
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', main);
} else {
  main();
}
